import { GetChassisPlaceQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getChassisPlace/getChassisPlaceQuery.type';
import { getChassisPlaceFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getChassisPlace/getChassisPlaceQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getChassisPlaceQueryOptions = (
  params: GetChassisPlaceQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['chassisPlace', params],
    queryFn: () => getChassisPlaceFunction(params),
    enabled: params.enabled,
  });
};
